import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AgFloatingFilterComponent } from 'ag-grid-angular';
import { IFloatingFilterParams } from 'ag-grid-community';
import moment from 'moment';
import { IntegrationService } from '../../../shared/services/integration.service';
import { FormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-loading-overlay',
    template: ` <input
        class="ag-text-field-input"
        style="width:137px;"
        type="text"
        [(ngModel)]="currentValue"
        (click)="openMenu()"
        [ngClass]="currentValue ? 'input-background-active' : ''" />
        @if (!currentValue) {
          <span class="sdps-dropdown__icon sch-chevron-small-down"></span>
        }
        @if (currentValue) {
          <span class="sdps-text-secondary delete-icon-padding" (click)="clearDateField($event, parentModel)"
            ><img class="deleteIcon" [src]="deleteIcon"
          /></span>
        }`,
    styleUrls: ['./date-floating-filter.component.scss'],
    standalone: true,
    imports: [FormsModule, NgClass]
})
export class DateFloatingFilterComponent implements OnInit, AgFloatingFilterComponent {
  @ViewChild('eInput', { read: ElementRef }) eInput: ElementRef;
  private params: IFloatingFilterParams;
  currentValue: Number | null | string = null;
  public deleteIcon: string;
  constructor(private integrationService: IntegrationService) {}

  ngOnInit(): void {
    const assetUrl = this.integrationService.getApplicationPath();
    this.deleteIcon = assetUrl + 'assets/images/Delete.svg';
  }

  agInit(params: IFloatingFilterParams): void {
    this.params = params;
  }

  openMenu(): void {
    this.params.api.showColumnFilter(this.params.column.getColId());
  }

  onParentModelChanged(parentModel: any): void {
    // When the filter is empty we will receive a null value here
    if (!parentModel) {
      this.currentValue = null;
    } else {
      let formattedDateString;
      if (
        parentModel.dateFrom &&
        (parentModel.type == 'equals' || parentModel.type == 'greaterThanOrEqual' || parentModel.type == 'lessThanOrEqual')
      ) {
        formattedDateString = moment(moment(parentModel.dateFrom)).format('MM/DD/YYYY');
      }
      if (parentModel.dateTo && parentModel.type === 'inRange') {
        formattedDateString = this.truncateStr(
          moment(moment(parentModel.dateFrom)).format('MM/DD/YYYY') +
            ' - ' +
            moment(moment(parentModel.dateTo)).format('MM/DD/YYYY')
        );
      }
      this.currentValue = formattedDateString;
    }
  }
  private truncateStr(str): string {
    if (str.length > 10) {
      return str.substr(0, 7) + '...';
    }
  }
  clearDateField(event): void {
    event.preventDefault();
    this.currentValue = null;
    const colID = this.params.column.getColId();
    this.params.api.setColumnFilterModel(colID, null);
    this.params.api.onFilterChanged();
  }
}
